export interface EventConfig {
  hero: {
    title: string;
    mobileTitle: string[];
    dates: string;
    appStoreUrl: string;
  };
  normalShow: {
    title: string;
    mobileTitle: string[];
    description: string;
    mobileDescription: string[];
    eventbriteUrl: string;
  };
  featuredStylists: {
    title: string;
    mobileTitle: string[];
    description: string;
    mobileDescription: string[];
  };
  finalCallout: {
    title: string;
    mobileTitle: string[];
    description: string;
  };
}

export const eventConfig: EventConfig = {
  hero: {
    title: 'Shop with an EMME stylist at Not-A-Normal Show NYC',
    mobileTitle: [
      'Shop with an',
      'EMME stylist',
      'at Not-a-normal',
      'show NYC',
    ],
    dates: 'Sept 19-21 & 26-28',
    appStoreUrl: 'https://apps.apple.com/us/app/emme-styling/id6742431174',
  },
  normalShow: {
    title:
      'Not-A-Normal Show is a two-weekend shopping, community, and cultural event by Normal New York',
    mobileTitle: [
      'Not-A-Normal Show',
      'is a two-weekend shopping,',
      'community, and cultural event',
      'by Normal New York',
    ],
    description:
      "Featuring over 300 carefully curated vendors of vintage, secondhand, handmade, and locally produced goods-it's the perfect place for fashion enthusiasts to discover unique pieces with expert guidance from your personal stylist.",
    mobileDescription: [
      "Featuring over 300 carefully curated vendors of vintage, secondhand, handmade, and locally produced goods-it's the perfect place for fashion enthusiasts to discover unique pieces with expert guidance from your personal stylist.",
      '',
      "Visit Normal's Eventbrite for more information and to purchase tickets.",
    ],
    eventbriteUrl:
      'https://www.eventbrite.com/e/not-a-normal-show-fall-2025-nyc-tickets-1553285100549?utm-campaign=social&utm-content=attendeeshare&utm-medium=discovery&utm-term=listing&utm-source=cp&aff=ebdsshcopyurl',
  },
  featuredStylists: {
    title: 'FEATURED STYLISTS',
    mobileTitle: ['FEATURED', 'STYLISTS'],
    description:
      'Meet our expert stylists at Not-A-Normal Show. Discover your next one-of-a-kind piece in a personalized session—book your one-on-one through the EMME app.',
    mobileDescription: [
      'Meet some of our expert stylists who',
      'will be at Not-A-Normal Show.',
      '',
      'Book a 1:1 styling session at the event to find something',
      'special with your personal expert stylist. More available in the',
      'app.',
    ],
  },
  finalCallout: {
    title: 'READY TO GET STYLED?',
    mobileTitle: ['READY TO GET', 'STYLED?'],
    description:
      "Don't shop alone at Not-A-Normal Show. Book your personal stylist now and discover pieces you'll love forever.",
  },
};
